import React from "react";
import api from '../../api/Api'
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Datetime from "react-datetime";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import Grid from "@material-ui/core/Grid";
import Button from "components/CustomButtons/Button.jsx";
import LocalHospital from "@material-ui/icons/TrendingUp";


import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// react plugin for creating vector maps
import {VectorMap} from "react-jvectormap";
import Chartist from 'chartist';
// import * as ChartistTooltips from 'chartist-plugin-tooltips';
// import ctPointLabels from '../../variables/chartUtil.js';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";


import Refresh from "@material-ui/icons/Refresh";
import Edit from "@material-ui/icons/Edit";
import NavPills from "components/NavPills/NavPills.jsx";
import Assignment from "@material-ui/icons/Assignment";
import DateRange from "@material-ui/icons/DateRange";
import Person from "@material-ui/icons/Person";

import {Redirect} from 'react-router';
import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
// core components
import {
    dailySalesChart,
    emailsSubscriptionChart,
    completedTasksChart
} from "variables/charts";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import {
    isClinicMasterOrClinic,
    clinicmaster_id,
    getClinicUserId
} from '../../util/globalHelper';
import Loader from '../../components/Loader'
var ChartTooltip = require('chartist-plugin-tooltips');

let a = [];
var delays = 80,
    durations = 500;
var delays2 = 80,
    durations2 = 500;
function maxValue(array) {
    return Math.max(...array)
}

const option = {
    data: {
        labels: [1, 2, 3],
        series: [
            [
                {meta: 'description', value: 1},
                {meta: 'description', value: 5},
                {meta: 'description', value: 3}
            ],
            [
                {meta: 'other description', value: 2},
                {meta: 'other description', value: 4},
                {meta: 'other description', value: 2}
            ]
        ]
    },
    options: {
        lineSmooth: Chartist.Interpolation.cardinal({
            tension: 0
        }),
        showPoint: true,
        low: 0,
        high: {
            draw: function (data) {
               return  Math.max(...data.series) + 10
            }

        }, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
        chartPadding: {
            top: 20,
            right: 0,
            bottom: 0,
            left: 0,
        },
        axisY: {
            onlyInteger: true
        },
        plugins: [
            // ctPointLabels({
            //     textAnchor: 'middle'
            // })
            Chartist.plugins.tooltip()

        ]
    },
    // for animation
    animation: {
        draw: function (data) {
            if (data.type === "line" || data.type === "area") {
                data.element.animate({
                    d: {
                        begin: 600,
                        dur: 700,
                        from: data.path
                            .clone()
                            .scale(1, 0)
                            .translate(0, data.chartRect.height())
                            .stringify(),
                        to: data.path.clone().stringify(),
                        easing: Chartist.Svg.Easing.easeOutQuint
                    }
                });
            } else if (data.type === "point") {
                data.element.animate({
                    opacity: {
                        begin: (data.index + 1) * delays,
                        dur: durations,
                        from: 0,
                        to: 1,
                        easing: "ease"
                    }
                });
            }
        }
    }
};

class Analytics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clinicsData: null,
            clinicmaster_id: null,
            analyticsList: null,
            data: null,
            open: true,
            element: "",
            api_status: "",
            read: false,
            alert: null,
            clinicMasterList: null,
            clickedId: "",
            selectedId: "",
            value: 0,
            reportLabel: [],
            reportSeries: [],
            appointmentLabel: [],
            appointmentSeries: [],
            patientLabel: [],
            patientSeries: [],
            reportGraph: {},
            appointmentGraph: {},
            patientGraph: {},
            graphType: 2,
            start_date: "",
            end_date: "",
            otpReport: null,
            patientReportAnalytics: null
        };

        this.searchOnFilter = this.searchOnFilter.bind(this);

        this.onChange = this.onChange.bind(this)
        this.changeGraph = this.changeGraph.bind(this)
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }

    renderGraphValue(array) {
        return array.map(item => {
            a.push.apply(a, Object.values(item))
            return Object.keys(item)
        })
    }

    renderGraphKeys(array) {
        return array.map(item => {
            a.push.apply(a, Object.keys(item))
            return Object.keys(item)
        })
    }

    renderGraphKey(array) {
        return array.map(item => {
            a.push.apply(a, Object.keys(item))
            return Object.keys(item)
        })
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    onChange(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.changeGraph(e.target.value)
        //
        // this.setState({graphType: e.target.value}, () => {
        //     this.changeGraph(this.state.graphType)
        // });

    }

    searchOnFilter() {
        this.setState({data: []})
        var postBody = {
            clinic_id: this.state.clinic_id,
            clinicmaster_id: this.state.clinicmaster_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            type: this.state.graphType
        }
        api.fetAnalytticsStats(postBody).then(json => {
            this.setState({
                data: json.data.data,
                reportLabel: Object.keys(json.data.data.report_details),
                reportSeries: [Object.values(json.data.data.report_details)],
                appointmentLabel: Object.keys(json.data.data.appointment_details),
                appointmentSeries: [Object.values(json.data.data.appointment_details)],
                patientLabel: Object.keys(json.data.data.patient_details),
                patientSeries: [Object.values(json.data.data.patient_details)]
            }, () => {
                this.setState({
                    analyticsList: this.state.data,
                    reportGraph: {
                        labels: this.state.reportLabel,
                        series: this.state.reportSeries
                    },
                    appointmentGraph: {
                        labels: this.state.appointmentLabel,
                        series: this.state.appointmentSeries
                    },
                    patientGraph: {
                        labels: this.state.patientLabel,
                        series: this.state.patientSeries
                    }


                })
            })
        });

    }

    handleChange = (event, value) => {
        this.setState({value});
    };
    handleChangeIndex = index => {
        this.setState({value: index});
    };

    componentDidMount() {
        this.setState({clinicmaster_id: clinicmaster_id(), clinic_id: getClinicUserId()}, () => {
            this.CallReadApi()
        })
    }

    render() {
        const {classes} = this.props;
        const {data, patientReportAnalytics, clinicMasterList, otpReport, clinicsData, analyticsList} = this.state;
       if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id || this.state.clinicsData === [])) {this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id) }
        if (this.state.clinicMasterList)
            return (
                <div>

                    {this.state.alert}

                    <Grid container>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4>Analytics</h4>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                    {/*
                                     <span>
                                     <GridContainer>

                                     <GridItem xs={12} sm={6} md={6}>
                                     </GridItem>
                                     <GridItem xs={12} sm={6} md={6}>

                                     </GridItem>
                                     </GridContainer>
                                     </span>*/}
                                </CardHeader>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={4} className="centerDiv">
                                            <FormControl fullWidth>
                                                <Datetime
                                                    timeFormat={false}
                                                    // value={this.state.start_date}
                                                    name="start_date"
                                                    defaultValue={new Date()}
                                                    dateFormat={"DD MMMM, YYYY"}
                                                    closeOnSelect={true}
                                                    color="warning"
                                                    onChange={event => this.handleChangeStartDate(event)}
                                                    inputProps={{placeholder: "Start Date"}}/>
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4} className="centerDiv">
                                            <FormControl fullWidth>
                                                <Datetime
                                                    timeFormat={false}
                                                    // value={this.state.end_date}
                                                    defaultValue={new Date()}
                                                    dateFormat={"DD MMMM, YYYY"}
                                                    closeOnSelect={true}
                                                    color="info"
                                                    name="end_date"
                                                    onChange={event => this.handleChangeEndDate(event)}
                                                    inputProps={{placeholder: "End Date"}}/>
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4} className="centerDiv">

                                            {isClinicMasterOrClinic() === "" ?
                                                <FormControl
                                                    fullWidth>
                                                    <InputLabel
                                                        htmlFor="clinicmaster_id">
                                                        Clinic Master
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.clinicmaster_id}
                                                        onChange={this.onChangeSelect}
                                                        inputProps={{
                                                            name: "clinicmaster_id",
                                                            id: "clinicmaster_id"
                                                        }}
                                                    >
                                                        <MenuItem
                                                            disabled
                                                        >
                                                            Select Clinic
                                                        </MenuItem>
                                                        {clinicMasterList.map((x) => {
                                                            return <MenuItem key={Math.random()}
                                                                             style={{height: "1.8em"}}
                                                                             value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl> : null}
                                            <br /><br />
                                        </GridItem>
                                    </GridContainer>
                                    {/* Clinic Option */}
                                    {isClinicMasterOrClinic() === "" && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={4} className="centerDiv">
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4} className="centerDiv">
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4} className="centerDiv">
                                                <br /><br /><br />
                                                <FormControl fullWidth>
                                                    <InputLabel htmlFor="clinic_id">
                                                        Clinic
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.clinic_id}
                                                        onChange={this.onChangeSelect}
                                                        inputProps={{
                                                            name: "clinic_id",
                                                            id: "clinic_id"
                                                        }}
                                                    >
                                                        <MenuItem disabled>
                                                            Select Clinic
                                                        </MenuItem>
                                                        {clinicsData.map((x) => {
                                                            return <MenuItem key={Math.random()}
                                                                             style={{height: "1.8em"}}
                                                                             value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                            </GridItem>

                                        </GridContainer> : null}

                                    <GridContainer>
                                        <br/><br/>
                                        <br/><br/>
                                        <GridItem xs={12} sm={12} md={12} className="centerDiv">
                                            <Button size="lg" onClick={this.searchOnFilter}
                                                    color="warning">Search</Button>
                                        </GridItem>
                                        <br/><br/>
                                        <br/><br/>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    {

                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <h3 className="centerDiv" justify="center">
                                                    Counts
                                                </h3>
                                                <br />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4} className="centerDiv">
                                                <h5>
                                                    <b>Patients:</b>&nbsp;&nbsp;&nbsp;{analyticsList ? analyticsList.patient_count : 0}
                                                </h5>
                                            </GridItem>
                                            <br/><br/>
                                            <br/><br/>
                                            <GridItem xs={12} sm={12} md={4} className="centerDiv">
                                                <h5>
                                                    <b>Appointments:</b>&nbsp;&nbsp;&nbsp;{analyticsList ? analyticsList.appointments_count : 0}
                                                </h5>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={4} className="centerDiv">
                                                <h5>
                                                    <b>Reports:</b>&nbsp;&nbsp;&nbsp;{analyticsList ? analyticsList.reports_count : 0}
                                                </h5>
                                            </GridItem>
                                        </GridContainer>
                                    }
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <GridContainer justify="center">
                                        <GridItem xs={12} sm={12} md={8}>
                                            <h3 className="centerDiv" justify="center">
                                                Trends
                                            </h3>
                                            <br />
                                            <GridContainer>

                                                <GridItem xs={12} sm={12} md={12}>
                                                    <div style={{padding: '20px', margin: 'auto'}}>
                                                        <ul className="appointmentTiming centerDiv">
                                                            <li>
                                                                <input name="slot"
                                                                       defaultChecked={this.state.graphType === 4}
                                                                       type="radio" onChange={this.onChange}
                                                                       id={"day"} value={4}/>
                                                                <label htmlFor={"day"}>{"Day"}</label>
                                                            </li>
                                                            <li>
                                                                <input name="slot"
                                                                       defaultChecked={this.state.graphType === 1}
                                                                       type="radio" onChange={this.onChange}
                                                                       id={"week"} value={1}/>
                                                                <label htmlFor={"week"}>{"Week"}</label>
                                                            </li>
                                                            <li>
                                                                <input name="slot"
                                                                       defaultChecked={this.state.graphType === 2}
                                                                       type="radio" onChange={this.onChange}
                                                                       id={"month"} value={2}/>
                                                                <label htmlFor={"month"}>{"Month"}</label>
                                                            </li>
                                                            {/*<li>
                                                             <input name="slot"
                                                             defaultChecked={this.state.graphType === 3}
                                                             type="radio" onChange={this.onChange}
                                                             id={"year"} value={3}/>
                                                             <label htmlFor={"year"}>{"Year"}</label>
                                                             </li>*/}

                                                        </ul>
                                                    </div>
                                                </GridItem>

                                            </GridContainer>
                                            <br/>
                                            <br/>
                                            <br/>
                                            <NavPills
                                                color="warning"
                                                alignCenter
                                                tabs={[
                                                    {
                                                        tabButton: "Patients",
                                                        tabIcon: Person,
                                                        tabContent: (
                                                            <Card chart className={classes.cardHover}
                                                                  style={{border: "1px solid #eaeaea"}}>
                                                                <CardHeader color="info">
                                                                    <ChartistGraph
                                                                        className="ct-chart-white-colors"
                                                                        data={this.state.patientGraph}
                                                                        type="Line"
                                                                        options={option.options}
                                                                        listener={completedTasksChart.animation}
                                                                    />
                                                                </CardHeader>
                                                                <CardBody>
                                                                    <div className={classes.cardHoverUnder}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Refresh"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}
                                                                        >
                                                                            <Button simple color="info" justIcon>
                                                                                <Refresh
                                                                                    className={classes.underChartIcons}/>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Change Date"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}
                                                                        >
                                                                            <Button color="transparent" simple justIcon>
                                                                                <Edit
                                                                                    className={classes.underChartIcons}/>
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </div>
                                                                    <h4 className={classes.cardTitle}>Patients</h4>
                                                                    {/*<p className={classes.cardCategory}>*/}
                                                                    {/*Last Campaign Performance*/}
                                                                    {/*</p>*/}
                                                                    <br />
                                                                    Dramatically visualize the trend of patient
                                                                    registrations over time.
                                                                    <br />
                                                                    <br />
                                                                    <div><a><span>View Raw Data</span></a></div>
                                                                </CardBody>
                                                                {/*<CardFooter chart>
                                                                 <div className={classes.stats}>
                                                                 <AccessTime /> campaign sent 2 days ago
                                                                 </div>
                                                                 </CardFooter>*/}
                                                            </Card>
                                                        )
                                                    },
                                                    {
                                                        tabButton: "Reports",
                                                        tabIcon: Assignment,
                                                        tabContent: (
                                                            <Card chart className={classes.cardHover}
                                                                  style={{border: "1px solid #eaeaea"}}>
                                                                <CardHeader color="info">
                                                                    <ChartistGraph
                                                                        className="ct-chart-white-colors"
                                                                        data={this.state.reportGraph}
                                                                        type="Line"
                                                                        options={option.options}
                                                                        listener={dailySalesChart.animation}
                                                                    />
                                                                </CardHeader>
                                                                <CardBody>
                                                                    <div className={classes.cardHoverUnder}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Refresh"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}
                                                                        >
                                                                            <Button simple color="info" justIcon>
                                                                                <Refresh
                                                                                    className={classes.underChartIcons}/>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Change Date"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}
                                                                        >
                                                                            <Button color="transparent" simple justIcon>
                                                                                <Edit
                                                                                    className={classes.underChartIcons}/>
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </div>
                                                                    <h4 className={classes.cardTitle}>Reports</h4>
                                                                    <br />
                                                                    Dynamically visualize quality service delivery with
                                                                    the trend of reports delivered to patients over
                                                                    time.
                                                                    <br />
                                                                    <br />
                                                                    <div><a><span>View Raw Data</span></a></div>
                                                                </CardBody>
                                                                {/* <CardFooter chart>
                                                                 <div className={classes.stats}>
                                                                 <AccessTime /> updated 4 minutes ago
                                                                 </div>
                                                                 </CardFooter> */}
                                                            </Card>
                                                        )
                                                    },
                                                    {
                                                        tabButton: "Appointments",
                                                        tabIcon: DateRange,
                                                        tabContent: (
                                                            <Card chart className={classes.cardHover}
                                                                  style={{border: "1px solid #eaeaea"}}>
                                                                <CardHeader color="warning">
                                                                    <ChartistGraph
                                                                        className="ct-chart-white-colors"
                                                                        data={this.state.appointmentGraph}
                                                                        type="Line"
                                                                        options={option.options}
                                                                        listener={dailySalesChart.animation}
                                                                    />
                                                                </CardHeader>
                                                                <CardBody>
                                                                    <div className={classes.cardHoverUnder}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Refresh"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}
                                                                        >
                                                                            <Button simple color="info" justIcon>
                                                                                <Refresh
                                                                                    className={classes.underChartIcons}/>
                                                                            </Button>
                                                                        </Tooltip>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Change Date"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}
                                                                        >
                                                                            <Button color="transparent" simple justIcon>
                                                                                <Edit
                                                                                    className={classes.underChartIcons}/>
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </div>
                                                                    <h4 className={classes.cardTitle}>Appointments</h4>
                                                                    Dynamically visualize the business growth and
                                                                    service delivery with trends of appointments over
                                                                    time.
                                                                    <br />
                                                                    <br />
                                                                    <div><a><span>View Raw Data</span></a></div>
                                                                </CardBody>
                                                                {/* <CardFooter chart>
                                                                 <div className={classes.stats}>
                                                                 <AccessTime /> campaign sent 2 days ago
                                                                 </div>
                                                                 </CardFooter>*/}
                                                            </Card>
                                                        )
                                                    }
                                                ]}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                            <Card >
                                <CardBody>
                                    <h5>OTP Report Analytics</h5>
                                    {otpReport !== null ?
                                        <ReactTable
                                            data={otpReport}
                                            filterable
                                            defaultFilterMethod={(filter, row) =>
                                            String(row[filter._id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Date",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {otpReport[index].date}
                                                                    </div>
                                                                )
                                                        },
                                                        {
                                                            Header: "Reports Count",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {otpReport[index].reports_count}
                                                                    </div>
                                                                )
                                                        },

                                                        {
                                                            Header: "Requested OTP",

                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {otpReport[index].request_otps}
                                                                    </div>
                                                                )
                                                        },
                                                        {

                                                            Header: "OTP Verified",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {otpReport[index].otps_verified}
                                                                    </div>
                                                                )
                                                        }

                                                    ]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                        : null}
                                </CardBody>
                            </Card>
                            <Card >
                                <CardBody>
                                    <h5>Patient Report Analytics</h5>
                                    {patientReportAnalytics !== null ?
                                        <ReactTable
                                            data={patientReportAnalytics}
                                            filterable
                                            defaultFilterMethod={(filter, row) =>
                                            String(row[filter._id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Date",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {patientReportAnalytics[index].date}
                                                                    </div>
                                                                )
                                                        },
                                                        {
                                                            Header: "Reports Count",

                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {patientReportAnalytics[index].reports_count}
                                                                    </div>
                                                                )
                                                        },
                                                        {
                                                            Header: "Old Patients",

                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {patientReportAnalytics[index].old_patient}
                                                                    </div>
                                                                )
                                                        },
                                                        {
                                                            Header: "New Patients",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {patientReportAnalytics[index].new_patient}

                                                                    </div>
                                                                )
                                                        }


                                                    ]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                        : null}
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            )
        else return (<div>
            <Loader/>
        </div>)
    }

    CallReadApi = () => {
        var postBody = {
            "clinic_master_id": this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            "clinic_id": this.state.clinic_id ? this.state.clinic_id : "",
        };
        api.getOtpAnalytics({
            type: this.state.graphType,
            clinic_id: this.state.clinic_id ? this.state.clinic_id : "",
            clinicmaster_id: this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            start_date: this.state.start_date ? this.state.start_date : null,
            end_date: this.state.end_date ? this.state.end_date : null,
        }).then(json => {
            this.setState({otpReport: json.data.data})
        });
        api.getReportsPatientsAnalytics({
            type: this.state.graphType,
            clinic_id: this.state.clinic_id ? this.state.clinic_id : "",
            clinicmaster_id: this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            start_date: this.state.start_date ? this.state.start_date : null,
            end_date: this.state.end_date ? this.state.end_date : null,
        }).then(json => {
            this.setState({patientReportAnalytics: json.data.data})

        });
        // api.fetAnalytticsStats({"start_date": "2018-01-01", "end_date": "2019-01-01","type":3 }).then(json => {
        api.fetAnalytticsStats({
            type: this.state.graphType,
            clinic_id: this.state.clinic_id ? this.state.clinic_id : "",
            clinicmaster_id: this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            start_date: this.state.start_date ? this.state.start_date : null,
            end_date: this.state.end_date ? this.state.end_date : null,
        }).then(json => {
            this.setState({
                data: json.data.data,
                reportLabel: Object.keys(json.data.data.report_details),
                reportSeries: [Object.values(json.data.data.report_details).map(b => {
                    return {meta: "Report:", value: b}
                })],
                appointmentLabel: Object.keys(json.data.data.appointment_details),
                appointmentSeries: [Object.values(json.data.data.appointment_details).map(b => {
                    return {meta: "Appointment:", value: b}
                })],
                patientLabel: Object.keys(json.data.data.patient_details),
                patientSeries: [Object.values(json.data.data.patient_details).map(b => {
                    return {meta: "Patient:", value: b}
                })]
            }, () => {
                this.setState({
                    analyticsList: this.state.data,
                    reportGraph: {
                        labels: this.state.reportLabel,
                        series: this.state.reportSeries
                    },
                    appointmentGraph: {
                        labels: this.state.appointmentLabel,
                        series: this.state.appointmentSeries
                    },
                    patientGraph: {
                        labels: this.state.patientLabel,
                        series: this.state.patientSeries
                    }


                })
            })
        });
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}});
    };

    changeGraph(value) {
        api.fetAnalytticsStats({type: value}).then(json => {
            this.setState({
                graphType: value,
                data: json.data.data,
                reportLabel: Object.keys(json.data.data.report_details),
                reportSeries: [Object.values(json.data.data.report_details).map(b => {
                    return {meta: "Report:", value: b}
                })],
                appointmentLabel: Object.keys(json.data.data.appointment_details),
                appointmentSeries: [Object.values(json.data.data.appointment_details).map(b => {
                    return {meta: "Appointment:", value: b}
                })],
                patientLabel: Object.keys(json.data.data.patient_details),
                patientSeries: [Object.values(json.data.data.patient_details).map(b => {
                    return {meta: "Patient:", value: b}
                })],
                analyticsList: json.data.data,
                reportGraph: {
                    labels: Object.keys(json.data.data.report_details),
                    series: [Object.values(json.data.data.report_details).map(b => {
                        return {meta: "Report:", value: b}
                    })]
                },
                appointmentGraph: {
                    labels: Object.keys(json.data.data.appointment_details),
                    series: [Object.values(json.data.data.appointment_details).map(b => {
                        return {meta: "Appointment:", value: b}
                    })]
                }, patientGraph: {
                    labels: Object.keys(json.data.data.patient_details),
                    series: [Object.values(json.data.data.patient_details).map(b => {
                        return {meta: "Patient:", value: b}
                    })]
                }
            })
        });

    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
        var postBody = {
            "clinic_master_id": this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            "clinic_id": this.state.clinic_id ? this.state.clinic_id : "",
        };
        this.setState({data: null, analyticsList: null})
        if (this.state.clinic_id !== "" && this.state.clinic_master_id !== "")
            api.fetAnalytticsStats(postBody).then(json => {
                this.setState({data: json.data.data}, () => {
                    this.setState({
                        analyticsList: this.state.data
                    })
                })
            });
    }


    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }
}

export default withStyles(dashboardStyle)(Analytics);



// WEBPACK FOOTER //
// ./src/views/Analytics/Analytics.jsx